import React from "react";
import { AnalyticsCounterTemplate } from "themes/administration/analytics/components";

function AnalyticsCounter(props) {
    return <AnalyticsCounterTemplate {...props} />;
}

export default AnalyticsCounter;
